// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.item-description[data-v-65ad659c] {\n  display: block;\n  min-height: 65px;\n  max-height: 65px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-style: italic;\n  color: gray;\n}\n", ""]);
// Exports
module.exports = exports;
